import React from 'react'
import SupplyBillDeliveryTable from './SupplyBillDeliveryTable'
import SupplyBillDeliveryButton from './form/SupplyBillDeliveryButton'

const SupplyBillDeliveries = ({ supplyBillId, deliveries }) => {
  return (
    <div>
        <h4>Доставка</h4>

		<SupplyBillDeliveryButton
            supplyBillId={supplyBillId}
        />

        <SupplyBillDeliveryTable 
            // deliveries={deliveries}
        />
    </div>
  )
}

export default SupplyBillDeliveries